import React from "react";
import { ToastProvider } from "./components/modern_toast";
import Routes from "./routers";

function App() {
  return (
    <ToastProvider>
      <Routes />
    </ToastProvider>
  );
}

export default App;